/* v3-ingredients.js: <v3-ingredients> — search and "free from" filtering for the ingredients reference.
   Progressive: the find bar is rendered hidden and only revealed here, so without JavaScript every entry
   is on the page. Filtering only hides rows; it never edits a declaration.
   Count and empty strings come from locales through data attributes, with {shown} / {total} placeholders.
   Reads window.v3 (v3-core.js) for the shared field and index helpers. */
(function () {
  'use strict';

  function pressed(el) { return el.getAttribute('aria-pressed') === 'true'; }

  class V3Ingredients extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.v3-ingr__list');
      if (!this.list) return;
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-v3-ingr-item]'));
      if (!this.items.length) return;

      this.nodes = Array.prototype.slice.call(this.list.children);
      this.groups = this.nodes.filter(function (node) { return node.hasAttribute('data-v3-ingr-group'); });
      this.bar = this.querySelector('[data-v3-ingr-bar]');
      this.search = this.querySelector('[data-v3-ingr-search]');
      this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-v3-ingr-filter]'));
      this.clear = this.querySelector('[data-v3-ingr-clear]');
      this.count = this.querySelector('[data-v3-ingr-count]');
      this.empty = this.querySelector('[data-v3-ingr-empty]');
      this.pattern = this.getAttribute('data-count') || '';
      this.total = this.items.length;

      var self = this;
      if (this.bar) this.bar.hidden = false;
      this.buildContents();

      /* Escape clears the text only; the clear button also lifts the allergen chips */
      if (this.search) window.v3.filterField({ input: this.search, apply: function () { self.apply(); } });
      if (this.clear) this.clear.addEventListener('click', function () { self.reset(); });
      this.chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chip.setAttribute('aria-pressed', pressed(chip) ? 'false' : 'true');
          self.apply();
        });
      });

      this.apply();
    }

    /* Contents links are built here rather than in Liquid: the group headings are theme blocks, so the list of
       groups is only known once the section has rendered. */
    buildContents() {
      var nav = this.querySelector('[data-v3-ingr-contents]');
      if (!nav || this.groups.length < 2) return;
      var list = nav.querySelector('ul');
      if (!list) return;
      var entries = this.groups.map(function (group) {
        var heading = group.querySelector('h2');
        return { id: group.id, label: heading ? heading.textContent : group.id, group: group };
      });
      var built = window.v3.buildIndex(list, entries, { item: 'li' });
      this.links = built.map(function (b) { return { item: b.item, group: b.entry.group }; });
      nav.hidden = false;
    }

    reset() {
      if (this.search) this.search.value = '';
      this.chips.forEach(function (chip) { chip.setAttribute('aria-pressed', 'false'); });
      this.apply();
      if (this.search) this.search.focus();
    }

    apply() {
      var query = (this.search && this.search.value || '').toLowerCase().trim();
      var avoid = this.chips.filter(pressed).map(function (chip) { return chip.getAttribute('data-v3-ingr-filter'); });
      var shown = 0;

      this.items.forEach(function (item) {
        var has = ' ' + (item.getAttribute('data-allergens') || '') + ' ';
        var blocked = avoid.some(function (key) { return has.indexOf(' ' + key + ' ') !== -1; });
        var found = !query || (item.getAttribute('data-find') || '').indexOf(query) !== -1;
        item.hidden = blocked || !found;
        if (!item.hidden) shown++;
      });

      /* a group heading stays only while something under it survives the filter */
      var group = null, any = false;
      this.nodes.forEach(function (node) {
        if (node.hasAttribute('data-v3-ingr-group')) {
          if (group) group.hidden = !any;
          group = node;
          any = false;
        } else if (node.hasAttribute('data-v3-ingr-item') && !node.hidden) {
          any = true;
        }
      });
      if (group) group.hidden = !any;

      /* contents links follow their group, so the list never points at something that is filtered out */
      if (this.links) this.links.forEach(function (l) { l.item.hidden = l.group.hidden; });

      var filtering = !!query || avoid.length > 0;
      if (this.count) this.count.textContent = filtering ? this.pattern.replace('{shown}', shown).replace('{total}', this.total) : '';
      if (this.empty) this.empty.hidden = shown !== 0;
      if (this.clear) this.clear.hidden = !filtering;
    }
  }

  if (!customElements.get('v3-ingredients')) customElements.define('v3-ingredients', V3Ingredients);
})();
